import * as THREE from 'three';
import type { CharacterRole } from './characters.js';

export function patrolPath(role: CharacterRole, seed: number): THREE.Vector3[] {
  if (role === 'staff') {
    const paths = [
      [
        new THREE.Vector3(-8, 0, 0),
        new THREE.Vector3(-2, 0, 12),
        new THREE.Vector3(8, 0, -8),
        new THREE.Vector3(-14, 0, -2),
      ],
      [new THREE.Vector3(-2, 0, -10), new THREE.Vector3(8, 0, -10), new THREE.Vector3(10, 0, 2)],
      [new THREE.Vector3(-14, 0, 0), new THREE.Vector3(-8, 0, 6), new THREE.Vector3(0, 0, 10)],
    ];
    return paths[seed % paths.length];
  }
  const paths = [
    [new THREE.Vector3(-11, 0, 0), new THREE.Vector3(-8, 0, 4), new THREE.Vector3(-11, 0, 0)],
    [new THREE.Vector3(7, 0, 0), new THREE.Vector3(11, 0, 5), new THREE.Vector3(7, 0, 0)],
    [new THREE.Vector3(0, 0, 8), new THREE.Vector3(-4, 0, 12), new THREE.Vector3(0, 0, 8)],
  ];
  return paths[seed % paths.length];
}
